import api from '@pray/shared/utils/api';

import type { SeedTemplateResponse } from './types';

const TEMPLATES_URL = '/web/studio/admin/seed-emails/templates';

/**
 * The transactional templates a run can send.
 *
 * No parameters: the registry is 17 entries and the picker holds them all on one screen. The
 * envelope is unwrapped here, like every sibling in this folder.
 */
export async function getTemplates() {
  const res = await api.executeGetRequest<{ data: SeedTemplateResponse[] }>(TEMPLATES_URL);
  return res.data.data;
}
